import React, { useRef, useState } from 'react'
import { Carousel } from 'react-bootstrap'
import './MediaSidebar.scss'

export type MediaSidebar = {
  /** Public or pre-signed S3 URL to an audio file (mp3, m4a, wav, etc.) */
  audioUrl?: string;
  /** Array of image URLs (S3). Shown top-to-bottom. */
  imageUrls?: string[];
  className?: string;
};

export default function MediaSidebar({
  audioUrl,
  imageUrls = [],
  className,
}: MediaSidebar) {
  const [_, setDuration] = useState<number | null>(null)
  const audioRef = useRef<HTMLAudioElement | null>(null)

  return (
    <aside className={`MediaSidebar ${className && className}`} aria-label="Media sidebar">
      {audioUrl && (
        <audio
          ref={audioRef}
          className="w-100 mt-2"
          controls
          preload="metadata"
          src={audioUrl}
          onLoadedMetadata={e => setDuration(e.currentTarget.duration)}
        >
          Your browser does not support the audio element.
        </audio>
      )}
      <Carousel>
        {imageUrls.map((src, i) => (
          <Carousel.Item key={src ?? i}>
            <img
              src={src}
              alt={`Interview photo ${i + 1}`}
              loading="lazy"
              decoding="async"
            />
          </Carousel.Item>
        ))}
      </Carousel>
    </aside>
  )
}
